module.exports = __webpack_public_path__ + "media/easyToBeLandlordBanner.aa6c5646.png";